export default [
    {
        caption: 'Roadmap',
        id: 'road-map',
        items: [
            {
                name: 'React',
                url: 'https://reactjs.org/',
                describe: '技术栈核心'
            },
            {
                name: 'Developer Roadmap',
                url: 'https://github.com/kamranahmedse/developer-roadmap',
                describe: ''
            },
            {
                name: 'React Developer Roadmap',
                url: 'https://github.com/adam-golab/react-developer-roadmap',
                describe: ''
            },
            {
                name: 'Best of JavaScript',
                url: 'https://bestofjs.org/',
                describe: ''
            },
            {
                name: 'State of JavaScript 2018',
                url: 'https://2018.stateofjs.com/introduction',
                describe: ''
            }
        ]
    },
    {
        caption: '脚手架',
        id: 'scaffold',
        items: [
            {
                name: 'Create React App',
                url: 'https://github.com/facebook/create-react-app',
                describe: '单页应用'
            },
            {
                name: 'Storybook',
                url: 'https://github.com/storybooks/storybook',
                describe: '组件开发'
                // }, {
                //     name: 'Next.js',
                //     url: 'https://github.com/zeit/next.js',
                //     describe: '服务端渲染'
            },
            {
                name: 'Gatsby',
                url: 'https://github.com/gatsbyjs/gatsby',
                describe: '静态网站'
            },
            {
                name: 'Docz',
                url: 'https://github.com/pedronauck/docz',
                describe: '文档'
            }
        ]
    },
    {
        caption: '脚手架辅助工具',
        id: 'scaffold-tool',
        items: [
            {
                name: 'Prettier',
                url: 'https://github.com/prettier/prettier',
                describe: '格式化代码'
            },
            {
                name: 'ES Lint',
                url: 'https://eslint.org/',
                describe: '代码检查'
            },
            {
                name: 'Source Map Explorer',
                url: 'https://github.com/danvk/source-map-explorer',
                describe: 'Source Map 查看'
            },
            {
                name: 'Sass',
                url: 'https://sass-lang.com/',
                describe: 'CSS 预处理器'
            },
            {
                name: 'PostCSS',
                url: 'https://postcss.org/',
                describe: 'CSS 处理器'
            }
        ]
    },
    {
        caption: 'UI Kit',
        id: 'ui-kit',
        items: [
            {
                name: 'Ant Design',
                url: 'https://ant.design',
                describe: 'Web'
            },
            {
                name: 'Ant Design Pro',
                url: 'https://pro.ant.design',
                describe: 'Web Admin'
            },
            {
                name: 'Ant Design Mobile',
                url: 'https://mobile.ant.design',
                describe: 'Mobile Web'
            }
        ]
    },
    {
        caption: '功能库',
        id: 'Basic',
        items: [
            {
                name: 'PropTypes',
                url: 'https://github.com/facebook/prop-types',
                describe: '数据类型验证'
            },
            {
                name: 'Flow',
                url: 'https://github.com/facebook/flow',
                describe: '静态类型检查'
            },
            {
                name: 'React Router',
                url: 'https://github.com/ReactTraining/react-router',
                describe: '路由'
            },
            {
                name: 'Fetch',
                url: 'https://github.com/github/fetch',
                describe: '数据请求'
            },
            {
                name: 'React Helmet',
                url: 'https://github.com/nfl/react-helmet',
                describe: '文档头管理'
            },
            {
                name: 'Immutable.js',
                url: 'https://github.com/facebook/immutable-js',
                describe: '不可变数据'
            },
            {
                name: 'Classnames',
                url: 'https://github.com/JedWatson/classnames',
                describe: '类名拼接'
            },
            {
                name: 'Emotion',
                url: 'https://github.com/emotion-js/emotion',
                describe: 'CSS in JS'
            }
        ]
    },
    {
        caption: '状态管理',
        id: 'Data',
        items: [
            {
                name: 'Redux',
                url: 'https://github.com/reduxjs/redux',
                describe: '状态管理'
            },
            {
                name: 'React Redux',
                url: 'https://github.com/reduxjs/react-redux',
                describe: '状态管理'
            },
            {
                name: 'Redux Thunk',
                url: 'https://github.com/reduxjs/redux-thunk',
                describe: '异步数据流控制'
            },
            {
                name: 'Redux Saga',
                url: 'https://github.com/redux-saga/redux-saga',
                describe: '异步数据流控制'
            }
        ]
    },
    {
        caption: '测试',
        id: 'Test',
        items: [
            {
                name: 'Jest',
                url: 'https://github.com/facebook/jest',
                describe: '单元测试框架'
            },
            {
                name: 'Enzyme',
                url: 'https://github.com/airbnb/enzyme',
                describe: '测试工具库'
            }
        ]
    },
    {
        caption: '其它',
        id: 'Other',
        items: [
            {
                name: 'Cordova',
                url: 'https://cordova.apache.org/',
                describe: 'Mobile App 构建'
            },
            {
                name: 'Crosswalk',
                url: 'https://crosswalk-project.org/',
                describe: 'WebView'
            }
        ]
    }
];
